import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import SearchInput from './SearchInput';
import { useDispatch } from 'react-redux';
import { addErrorNotification } from '../../state/notification/notifications';

const LocationSearch = ({ onSearch }) => {
	const { t } = useTranslation();
	const [address, setAddress] = useState('');
	const [results, setResults] = useState([]);
	const [isActive, setIsActive] = useState(false);
	const dropdownRef = useRef();
	const [isLoading, setIsLoading] = useState(false);
	const dispatch = useDispatch();

	const handleSearch = async (address) => {
		setIsLoading(true);
		try {
			const response = await axios.get(
				'https://nominatim.openstreetmap.org/search',
				{
					params: {
						q: address,
						format: 'json',
						viewbox: '13.3653,46.8767,16.5965,45.4219', // Restrict the search to Slovenia
						bounded: 1,
						countrycodes: 'SI',
					},
				}
			);
			if (response.data.length > 0) {
				setResults(response.data);
				setIsActive(true);
			} else {
				setResults([]);
				setIsActive(false);
				dispatch(
					addErrorNotification({
						title: t('address_not_found_title'),
						content: t('address_not_found_content'),
					})
				);
			}
		} catch (error) {
			dispatch(
				addErrorNotification({
					title: t('search_error_title'),
					content: t('search_error_content'),
				})
			);
			setIsActive(false);
		}
		setIsLoading(false);
	};

	const handleResultClick = (lat, lon) => {
		onSearch(lat, lon);
		setAddress('');
		setResults([]);
		setIsActive(false);
		setIsLoading(false);
	};

	const handleClickOutside = (event) => {
		if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
			setIsActive(false);
			setIsLoading(false);
		}
	};

	useEffect(() => {
		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, []);

	return (
		<div ref={dropdownRef} className="dropdown">
			<SearchInput
				value={address}
				onChange={(e) => setAddress(e)}
				placeholder={t('search')}
				onEnter={() => handleSearch(address)}
				onClick={() => handleSearch(address)}
				isLoading={isLoading}
			/>
			{results?.length > 0 && (
				<ul
					className={`dropdown-container scrollbar ${
						isActive ? 'is-active' : ''
					}`}>
					{results.map((result) => (
						<li
							key={result.lat + '_' + result.lon}
							onClick={() => {
								handleResultClick(result.lat, result.lon);
							}}>
							{result.display_name}
						</li>
					))}
				</ul>
			)}
		</div>
	);
};

export default LocationSearch;
